import React from 'react';
import AudioTrimmer from './AudioTrimmer.js';
import VideoTrimmer from './VideoTrimmer.js';

const MediaTrimmer = ({ file, onTrimmed }) => {
  const isAudio = file.type.startsWith('audio/');
  const isVideo = file.type.startsWith('video/');

  if (isAudio) {
    return <AudioTrimmer file={file} onTrimmed={onTrimmed} />;
  }

  if (isVideo) {
    return <VideoTrimmer file={file} onTrimmed={onTrimmed} />;
  }

  return <div>不支持的媒体类型: {file.type}</div>;
};

export default MediaTrimmer;
